import Fuse from 'fuse.js';

import { COURSE_FILTER, SORT_FILTER } from 'Util/Hooks/useCourseFilter/constants';

export const getFilterFromArray = (filters) => {
  const filterObj = {
    courses: 'CURRENT_COURSES',
    sort: '',
  };

  filters.forEach((filter) => {
    if (Object.values(COURSE_FILTER).includes(filter)) {
      filterObj.courses = filter;
    } else if (Object.values(SORT_FILTER).includes(filter)) {
      filterObj.sort = filter;
    }
  });
  return filterObj;
};

export const getFilteredItems = (items, filter) => {
  if (filter !== '') {
    const options = {
      threshold: 0.25,
      ignoreLocation: true,
      includeMatches: true,
      keys: [
        { name: 'title', getFn: (course) => course.courseInfo.title },
        { name: 'courseCode', getFn: (course) => course.courseInfo.courseCode },
      ],
    };
    const fuse = new Fuse(items, options);
    const filteredItems = fuse?.search(filter);
    return filteredItems;
  }

  return items;
};
